<template>
  <v-row>
    <v-col cols="12" v-if="loaderRetrieve">
      <v-skeleton-loader type="table-heading, list-item-two-line" />
      <v-skeleton-loader class="mt-5" type="table-heading, list-item-two-line" />
      <v-skeleton-loader class="mt-5" type="table" />
    </v-col>
    <template v-else>
      <!-- unpaid payments alert -->
      <v-col cols="12" v-if="isDue">
        <v-alert class="my-0 body-2" dark dense prominent color="deep-orange" border="left" type="info" icon="mdi-update">
          <v-row align="center">
            <v-col class="grow">
              La organización se encuentra en <span class="font-weight-medium">proceso de suspensión</span> dado que tiene pagos vencidos.
            </v-col>
            <v-col class="shrink">
              <v-btn @click="$vuetify.goTo($refs.payments, { offset: 20 })" color="deep-orange darken-4">Pagar facturas pendientes</v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </v-col>
      <!-- end unpaid payments alert -->

      <!-- panel subscription -->
      <v-col cols="12">
        <v-expansion-panels v-model="panelSubscription" multiple inset>
          <v-expansion-panel>
            <v-expansion-panel-header class="px-4 py-3">
              <v-row no-gutters align="center" justify="space-between">
                <v-col>
                  <span class="d-block text--secondary subtitle-1 font-weight-medium">Suscripción</span>
                </v-col>
                <v-col class="text-right mr-4" v-if="!panelSubscription.length">
                  <span class="d-block body-2">Pay as you go <v-chip class="ml-2" color="lightBlue" small text-color="primary">Mensual</v-chip></span>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="px-0">
              <v-row class="px-0">
                <v-col cols="3" class="ml-2">
                  <span class="d-block mb-1">Plan</span>
                  <v-btn class="mt-n1" @click="showStairs=true" color="primary" text :ripple="false">Pay as you go</v-btn>
                  <v-chip class="ml-2" color="lightBlue" small text-color="primary">Mensual</v-chip>
                </v-col>
                <v-divider class="my-2" vertical />
                <v-col cols="3" class="ml-2">
                  <span class="d-block mb-1">Usuarios activos</span>
                  <div class="body-1 text--secondary font-weight-medium">{{membersList.length}}</div>
                </v-col>
                <v-divider class="my-2" vertical />
                <v-col cols="3" class="ml-2">
                  <span class="d-block mb-1">Próxima facturación</span>
                  <div class="body-1 text--secondary font-weight-medium">
                    <template v-if="nextBilling === today">Hoy</template>
                    <template v-else>{{nextBilling | date}}</template>
                  </div>
                </v-col>
              </v-row>

              <!-- widgets -->
              <!-- <v-toolbar color="transparent" flat height="55">
                <v-toolbar-title class="ml-n2 text--secondary subtitle-1 font-weight-medium"><v-icon class="mt-n1" color="secondary" size="18" left>mdi-puzzle</v-icon>Widgets</v-toolbar-title>
              </v-toolbar>
              <v-divider />
              <v-row class="px-1">
                <v-list class="transparent" width="100%">
                  <v-list-item>
                    <v-list-item-title>
                      <v-btn :to="{name: 'FormList'}" color="primary" text :ripple="false">Signup Forms</v-btn>
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-right">
                      <span class="text--secondary body-1 font-weight-medium">2.2 CLF</span>
                      <span class="ml-2 text--primary">adicionales a tu suscripción</span>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>
                      <v-btn :to="{name: 'BaseList'}" color="primary" text :ripple="false">Customer Base</v-btn>
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-right text--primary">Inactivo</v-list-item-subtitle>
                  </v-list-item>
                  <v-list-item>
                    <v-list-item-title>
                      <v-btn color="primary" text :ripple="false">Pricing Pages</v-btn>
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-right text--primary">Inactivo</v-list-item-subtitle>
                  </v-list-item>
                </v-list>
              </v-row> -->
              <!-- end widgets -->

              <!-- integrations -->
              <!-- <v-toolbar color="transparent" flat height="55">
                <v-toolbar-title class="ml-n2 text--secondary subtitle-1 font-weight-medium"><v-icon class="mt-n1" color="secondary" size="18" left>mdi-connection</v-icon>Integraciones de pago</v-toolbar-title>
              </v-toolbar>
              <v-divider />
              <v-row class="px-1">
                <v-list class="transparent" width="100%">
                  <v-list-item>
                    <v-list-item-title>
                      <v-btn :to="{name: 'BillersBuiltInSettings'}" color="primary" text :ripple="false">Facturación incorporada</v-btn>
                    </v-list-item-title>
                    <span class="text--secondary body-1 font-weight-medium">Free</span>
                  </v-list-item>
                </v-list>
              </v-row> -->
              <!-- end integrations -->
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
      <!-- end panel subscription -->

      <!-- pricing plan dialog -->
      <v-dialog v-model="showStairs" width="700" persistent no-click-animation scrollable>
        <v-card>
          <v-card-title class="pa-0">
            <v-toolbar flat height="55">
              <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Niveles de precios plan Pay as you go</v-toolbar-title>
              <v-spacer />
              <v-toolbar-items>
                <v-row align="center" justify="center" class="mr-1">
                  <v-btn class="ml-3" @click="showStairs=false" icon small><v-icon size="24">mdi-close</v-icon></v-btn>
                </v-row>
              </v-toolbar-items>
            </v-toolbar>
          </v-card-title>
          <v-divider />
          <v-card-text class="pa-0 background">
            <v-simple-table dense>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th style="width: 450px !important;" class="text-left">Cantidad</th>
                    <th class="text-right">Precio</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="tier in stairs">
                    <tr :key="tier.to">
                      <td class="py-2">
                        <span class="mr-1">Desde</span>
                        <span class="text--secondary font-weight-medium">{{tier.quantity_from}}</span>
                        <span class="mx-1">a</span>
                        <span class="text--secondary font-weight-medium">{{tier.quantity_to}}</span>
                        <span class="mx-1">suscriptores activos</span>
                      </td>
                      <td class="text-right">
                        <span class="text--secondary font-weight-medium">{{tier.amount | currency(tier.currency)}}</span>
                        <span class="mx-1">{{tier.currency}}</span>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- end pricing plan dialog -->

      <!-- panel sources -->
      <v-col cols="12">
        <v-expansion-panels v-model="panelSource" multiple inset>
          <v-expansion-panel>
            <v-expansion-panel-header class="px-4 py-3">
              <v-row no-gutters align="center" justify="space-between">
                <v-col>
                  <span class="d-block text--secondary subtitle-1 font-weight-medium">Método de pago</span>
                </v-col>
                <v-col class="text-right mr-4" v-if="sourcesList.length || (!sourcesList.length && !panelSource.length)">
                  <v-btn @click.stop="createSource" outlined>Registrar una nueva tarjeta</v-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-header>
            <v-expansion-panel-content class="px-0">
              <v-row class="mx-n7 px-0">
                <v-col cols="12" class="ml-n1" v-if="sourcesList.length">
                  <v-list class="transparent">
                    <v-list-item v-for="(d, i) in sourcesList" :key="i">
                      <v-list-item-icon>
                        <img :src="require(`@/assets/appAsset-brand--${d.card.brand}.svg`)" :alt="d.card.brand" height="24">
                      </v-list-item-icon>
                      <v-list-item-title>
                        <span class="body-2 text--secondary font-weight-medium">•••• •••• •••• {{d.card.last4}}</span>
                        <v-tooltip right max-width="280px" v-if="i === 0" transition="scale-transition">
                          <template v-slot:activator="{on}">
                            <v-chip class="ml-4" v-on="on" color="lightBlue" small text-color="primary">Predeterminado</v-chip>
                          </template>
                          <span>La usaremos por defecto cuando cobremos tu suscripción</span>
                        </v-tooltip>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-col>
                <v-col cols="12" class="text-center" v-else>
                  <v-icon class="d-block" color="secondary" size="70">mdi-credit-card</v-icon>
                  <span class="d-block subtitle-1 mb-5">Registra una tarjeta para el pago de tu suscripción a Piriod</span>
                  <v-btn @click="createSource" outlined>Registrar una nueva tarjeta</v-btn>
                </v-col>
              </v-row>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
      <!-- end panel sources -->

      <!-- panel payments -->
      <v-col cols="12">
        <v-card ref="payments">
          <v-toolbar color="transparent" flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Pagos</v-toolbar-title>
          </v-toolbar>
          <v-divider />
          <v-card-text class="pa-0 background">
            <v-row no-gutters>
              <v-col cols="12" v-if="paymentsList.length">
                <v-data-table :headers="headersPayments" :items="paymentsList" :items-per-page="10" mobile-breakpoint hide-default-footer disable-sort>
                  <template v-slot:[`item.invoice`]="{item}">
                    <div class="py-2">
                      <span class="d-block">{{item.invoice.document}}</span>
                      <span class="d-block text--secondary font-weight-medium" v-if="item.status !== 'draft'">Nº {{item.invoice.number}}</span>
                    </div>
                  </template>
                  <template v-slot:[`item.status`]="{item}">
                    <v-row align="center" justify="end">
                      <v-chip v-if="item.status === 'succeeded'" color="lightBlue" small text-color="primary">Pagado<v-icon class="mx-1" x-small>mdi-check</v-icon></v-chip>
                      <v-chip v-else-if="item.status === 'requires_payment_method'" color="defaultGrey" small text-color="secondary">Incompleto</v-chip>
                      <v-chip v-else-if="item.status === 'failed'" color="defaultGrey" small text-color="secondary">Fallido</v-chip>
                      <v-chip v-else-if="item.status === 'cancelled'" color="defaultGrey" small text-color="secondary">Cancelado<v-icon class="mx-1" x-small>mdi-close</v-icon></v-chip>
                      <v-chip v-else-if="item.status === 'processing'" color="defaultGrey" small text-color="secondary">Procesando</v-chip>
                    </v-row>
                  </template>
                  <template v-slot:[`item.date`]="{item}">
                    <span class="body-2">{{item.invoice.date | date}}</span>
                  </template>
                  <template v-slot:[`item.due_date`]="{item}">
                    <span class="body-2 text--secondary font-weight-medium" v-if="item.invoice.due_date">{{item.invoice.due_date | date}}</span>
                    <span class="font-italic text--disabled" v-else>No especificado</span>
                  </template>
                  <template v-slot:[`item.amount`]="{item}">
                    <div class="text-right">
                      <span class="body-2 text--secondary font-weight-medium">{{item.amount | number(item.currency.rounded)}}</span> <span>{{item.currency.id}}</span>
                    </div>
                  </template>
                  <template v-slot:[`item.actions`]="{item}">
                    <div class="text-right" v-if="['requires_payment_method', 'failed'].includes(item.status)">
                      <v-btn :href="`${$PAY_BASE}/payments/${item.id}`" target="_blank" height="24" text color="primary" :ripple="false">Pagar<v-icon right>mdi-arrow-right</v-icon></v-btn>
                    </div>
                  </template>
                </v-data-table>
              </v-col>
              <v-col class="text-center py-5" v-else>
                <v-icon class="d-block" color="secondary" size="70">mdi-receipt</v-icon>
                <span class="d-block subtitle-1">Aún no se han registrado pagos en la organización</span>
              </v-col>
            </v-row>
          </v-card-text>
          <v-divider />
          <v-card-actions class="pa-4">
            <v-spacer />
          </v-card-actions>
        </v-card>
      </v-col>
      <!-- end panel payments -->
    </template>
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import GenericViewMixin from '@/mixins/GenericViewMixin'
import moment from 'moment'
export default {
  mixins: [
    GenericViewMixin
  ],
  data: () => ({
    headersPayments: [
      { text: 'Documento', value: 'invoice' },
      { text: '', value: 'status' },
      { text: 'Fecha', value: 'date', align: 'end' },
      { text: 'Vencimiento', value: 'due_date', align: 'end' },
      { text: 'Total', value: 'amount', align: 'end' },
      { text: '', value: 'actions' }
    ],
    isDue: false,
    nextBilling: moment().add(1, 'M').startOf('month').format('YYYY-MM-DD'),
    panelSource: [0],
    panelSubscription: [0],
    loaderRetrieve: false,
    showStairs: false,
    stairs: [
      { amount: 2.5, currency: 'CLF', quantity_from: 0, quantity_to: 200 },
      { amount: 2.7, currency: 'CLF', quantity_from: 201, quantity_to: 300 },
      { amount: 3.0, currency: 'CLF', quantity_from: 301, quantity_to: 400 },
      { amount: 3.3, currency: 'CLF', quantity_from: 401, quantity_to: 500 },
      { amount: 3.6, currency: 'CLF', quantity_from: 501, quantity_to: 600 },
      { amount: 3.9, currency: 'CLF', quantity_from: 601, quantity_to: 700 },
      { amount: 4.2, currency: 'CLF', quantity_from: 701, quantity_to: 800 },
      { amount: 4.6, currency: 'CLF', quantity_from: 801, quantity_to: 900 },
      { amount: 5.0, currency: 'CLF', quantity_from: 901, quantity_to: 1000 }
    ]
  }),
  computed: mapState({
    statesList: state => state.generals.statesList,
    accountsDetail: state => state.accounts.accountsDetail,
    membersList: state => state.accounts.membersList,
    paymentsList: state => state.accounts.paymentsList,
    sourcesList: state => state.accounts.sourcesList
  }),
  created () {
    this.loaderRetrieve = true
    Promise.all([
      this.$store.dispatch('accounts/LIST', {
        resource: 'billings/payments',
        query: {
          expand: 'invoice',
          ordering: '-invoice__due_date'
        }
      }),
      this.$store.dispatch('accounts/LIST', {
        resource: 'billings/sources',
        query: {
          gateway__usage: 'reusable',
          status: 'chargeable'
        }
      }),
      this.$store.dispatch('accounts/LIST', {
        resource: 'members',
        query: {
          is_active: 'True'
        }
      })
    ])
    .then(() => {
      this.isDue = this.paymentsList.filter(p => ['requires_payment_method', 'failed'].includes(p.status) && this.dateIsBefore(p.invoice.due_date, this.today)).length
      this.loaderRetrieve = false
    })
    .catch((error) => {
      if (error.response) {
        this.$dialog.message.error(this.parseErrors(error.response.data))
      }
    })
  },
  methods: {
    createSource () {
      this.$store.dispatch('accounts/CREATE', {
        resource: 'billings/sources',
        payload: {
          gateway: 'oneclick',
          return_url: `${this.$CLIENT_BASE}/account/settings/billing`
        },
        commitInstance: false
      })
      .then(response => {
        const source = response.data
        window.location.replace(`${this.$API_BASE}/sources/${source.id}/authorize/`)
      })
      .catch(error => {
        if (error.response) {
          this.$dialog.message.error(this.parseErrors(error.response.data))
        }
      })
    }
  }
}
</script>